import React, { Component } from "react";
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Button, Grid, Header, Icon, MessageProps, Transition } from 'semantic-ui-react';
import { Field } from 'react-final-form';
import { required } from 'utils/validatorUtils';
import Input from 'components/final-form/Input';
import styled from 'styled-components';
import LanguageDropdown from 'routes/login/segments/LanguageDropdown';
import PmVerificationInput from 'components/final-form/PmVerificationInput';

const StyledForgetPassword = styled(Button)`
  background: transparent !important;
  color: #2185d0 !important;

  :hover {
    text-decoration: underline;
  }
`;

interface Props extends MessageSourceProps {
  error: boolean,
  errorMessage: string,
  submitting: boolean,
  visible: boolean,
  transitionToCredentials: () => void,
  transitionToForgotPassword: () => void,
  transitionToRegistration: () => void,
  renderMessage: (header: string, text: string, messageProps: MessageProps) => React.ReactNode,
  verificationCodeKey: number,
  verificationCodeInput: boolean,
  verificationCodeError: boolean
}

class CredentialsSegment extends Component<Props> {

  render(): React.ReactNode {

    const {
      getMessage,
      error,
      errorMessage,
      visible,
      transitionToCredentials,
      transitionToForgotPassword,
      transitionToRegistration,
      renderMessage,
      submitting,
      verificationCodeInput,
      verificationCodeError
    } = this.props;

    let errorHeader = getMessage('login.error.header');
    let errorText = getMessage('login.error.invalid');

    if (errorMessage) {
      errorHeader = getMessage('general.unexpectedError');
      errorText = errorMessage;
    }

    const validator = visible ? required : undefined;

    if (verificationCodeInput) {
      return (
          <Transition animation={"fade left"} duration={400} visible={visible}>
            <div>
              <Header as='h2' icon textAlign='center'>
                <Header.Content>{getMessage('login.verificationCode.title')}</Header.Content>
              </Header>

              <Grid verticalAlign="middle">
                <Grid.Row verticalAlign="middle">
                  <Grid.Column>

                    <Field
                        key={this.props.verificationCodeKey}
                        name='verificationCode'
                        component={PmVerificationInput}
                        placeholder={getMessage('login.user.code')}
                        autoFocus={true}
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row verticalAlign="middle">
                  <Grid.Column>
                    <Button size='big' type='submit' primary fluid disabled={submitting} loading={submitting}>
                      {getMessage("login.button")}
                    </Button>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row verticalAlign="middle">
                  <Grid.Column>
                    <Button
                        basic
                        type="button"
                        fluid
                        onClick={evt => {
                          evt.preventDefault();
                          transitionToCredentials();
                        }}
                        disabled={submitting}
                    >
                      {getMessage("resetPassword.goToLogin")}
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              {
                verificationCodeError &&
                renderMessage(
                    "",
                    getMessage("login.verificationCode.invalidCode"),
                    { negative: true })
              }
            </div>
          </Transition>
      );
    }

    return (
        <Transition animation={"fade left"} duration={400} visible={visible}>
          <div>
            <Header as='h2' icon textAlign='center'>
              <Icon name='user' circular/>
              <Header.Content>{getMessage('login.user.text')}</Header.Content>
            </Header>
            <Field
                name='username'
                component={Input}
                placeholder={getMessage('login.user.username.hint')}
                icon='user'
                autoComplete="on"
                validate={validator}
            />
            <Field
                name='password'
                component={Input}
                type='password'
                placeholder={getMessage('login.user.password.hint')}
                icon='lock'
                autoComplete="on"
                validate={validator}
            />
            <Button size='big' type='submit' primary fluid disabled={submitting} loading={submitting}>
              {getMessage("login.button")}
            </Button>
            <StyledForgetPassword fluid onClick={transitionToForgotPassword} disabled={submitting}>
              {getMessage("login.forgotPassword")}
            </StyledForgetPassword>
            <StyledForgetPassword fluid onClick={transitionToRegistration} disabled={submitting}>
              {getMessage("login.registration")}
            </StyledForgetPassword>
            { error && renderMessage(errorHeader, errorText, { negative: true }) }
            <LanguageDropdown/>
          </div>
        </Transition>
    );
  }
}

export default withMessages(CredentialsSegment);
